import * as React from 'react'
function SvgStarMinus(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M19.06 5.73c.686 0 1.371.322 1.69.964l3.632 7.364 8.124 1.18c1.54.224 2.163 2.12 1.045 3.211l-2.419 2.357a4 4 0 01-2.791 1.135h-1.07a1.096 1.096 0 01-.765-1.881l1.688-1.644-4.352-.633-1.96-.284-.875-1.775-1.946-3.942-1.947 3.942-.875 1.775-1.96.284-4.351.633 3.149 3.068 1.417 1.381-.335 1.95-.743 4.334 3.892-2.046.132-.06a1.195 1.195 0 011.619 1.117v.15a3.522 3.522 0 01-1.883 3.116l-5.383 2.831c-.288.151-.585.219-.873.219-1.098 0-2.065-.992-1.858-2.204l1.387-8.093-5.88-5.73c-1.117-1.091-.496-2.989 1.044-3.213l8.126-1.18 3.633-7.362c.318-.642 1.004-.964 1.689-.964zm13.175 21.858a1.882 1.882 0 110 3.765h-7.53a1.882 1.882 0 110-3.765h7.53z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgStarMinus
